import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

// Relation summaries expose `image_scales` with presenter-relative download
// paths; fullobjects results expose `image.scales` with absolute URLs.
export const getSpeakerImageUrl = (presenter) => {
  const scales =
    presenter?.image_scales?.image?.[0]?.scales ?? presenter?.image?.scales;
  if (!scales) return null;
  const scale = scales.mini || scales.preview || Object.values(scales)[0];
  const download = scale?.download;
  if (!download) return null;
  const isAbsolute =
    /^(https?:)?\/\//.test(download) || download.startsWith('/');
  return flattenToAppURL(
    isAbsolute ? download : `${presenter['@id']}/${download}`,
  );
};

export const asList = (value) => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};
